import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageNotFoundComponent } from '@shared/components/page-not-found/page-not-found/page-not-found.component';
import { AuthGuard } from '@shared/guards/auth.guard';
import { CpLayoutComponent } from './cp-layout/cp-layout.component';

export enum RouteDataProps {
  hideSidebar = 'hideSidebar',
}

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./modules/auth/auth.module').then((m) => m.AuthModule),
    data: { [RouteDataProps.hideSidebar]: true },
  },

  { path: '', pathMatch: 'full', redirectTo: 'cp' },

  // second outlets
  {
    path: 'second/distributors',
    loadChildren: () => import('./modules/distributors/distributors.module').then((m) => m.DistributorsModule),
    canActivate: [ AuthGuard ],
    outlet: 'second',
  },
  {
    path: 'second/clients',
    loadChildren: () => import('./modules/clients/clients.module').then((m) => m.ClientsModule),
    canActivate: [ AuthGuard ],
    outlet: 'second',
  },

  // main routes: ControlPanel (cp)
  {
    path: 'cp',
    canActivate: [ AuthGuard ],
    component: CpLayoutComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'devices' },
      {
        path: 'devices',
        loadChildren: () => import('./modules/devices/devices.module').then((m) => m.DevicesModule),
        data: { key: 'devices' }
      },
      {
        path: 'distributors',
        loadChildren: () => import('./modules/distributors/distributors.module').then((m) => m.DistributorsModule),
      },
      {
        path: 'clients',
        loadChildren: () => import('./modules/clients/clients.module').then((m) => m.ClientsModule),
      },
      {
        path: 'proposals',
        loadChildren: () => import('./modules/proposals/proposals.module').then((m) => m.ProposalsModule),
      },
      {
        path: 'requests',
        loadChildren: () => import('./modules/requests/requests.module').then((m) => m.RequestsModule),
      },
      {
        path: 'notifications',
        loadChildren: () =>
          import('./modules/notifications/notifications.module').then((m) => m.NotificationsModule),
      },
      {
        path: 'updates',
        loadChildren: () => import('./modules/updates/updates.module').then((m) => m.UpdatesModule),
      },
      {
        path: 'users',
        loadChildren: () => import('./modules/users/users.module').then((m) => m.UsersModule),
      },
      {
        path: 'departments',
        loadChildren: () => import('./modules/departments/departments.module').then((m) => m.DepartmentsModule),
      },
      {
        path: 'tasks',
        loadChildren: () => import('./modules/tasks/tasks.module').then((m) => m.TasksModule),
      },
      {
        path: 'performers',
        loadChildren: () => import('./modules/performers/performers.module').then(m => m.PerformersModule)
      },
      {
        path: 'statistics',
        loadChildren: () => import('./modules/statistics/statistics.module').then(m => m.StatisticsModule)
      },
      { path: 'dev', loadChildren: () => import('./modules/dev/dev.module').then((m) => m.DevModule) },
      { path: '404', component: PageNotFoundComponent },
    ],
  },
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, { enableTracing: false }) ],
  exports: [ RouterModule ],
})
export class AppRoutingModule {
}
